(function($) {
    var __ = {

        body: $('body'),
        window: $(window),
        menuToggle: $('.j-menu--toggle'),
        menuSlide: $('.j-menu--slide'),
        menuContainer: $('.j-menu--container'),
        // Scene Controller
        controller: {},
        overlay: $('.pg-navigation--slideout-overlay'),

        // Toggle the menu class
        toggleMenu: function() {
            __.body.toggleClass('j-menu--open');
        },
        // Close the menu class
        closeMenu: function() {
            __.body.removeClass('j-menu--open');
        },

        // Watch for clicks on the menu toggle
        watchForClicks: function() {
            __.menuToggle.on('click', __.toggleMenu);
            __.overlay.on('click', __.closeMenu);

        },
        // Watch for page scrolling
        watchForScroll: function() {
            // var customEase = Power3.easeOut;
            var customEase = Power4.easeOut;
            // var customEase = CustomEase.create("custom", "M0,0 C0.132,-0.166 0.275,-0.369 0.416,-0.144 0.524,0.03 0.838,1 1,1");
            // var customEase = Bounce.easeOut;
            __.controller = new ScrollMagic.Controller();
            var menuTween = TweenMax.fromTo('.pg-toggle', 1, { height: '153px', ease: customEase }, { height: '100px', ease: customEase });
            var overlayToggle = TweenMax.to('.pg-navigation', 1, { height: '100px', ease: customEase });
            var menu = TweenMax.fromTo('.pg-navigation--slideout', 0.95,{ height: '1120px', ease: customEase },{ height: '0', ease: customEase }); 

            var timeline = new TimelineMax();
            timeline.add(menuTween).add(menu, '0').add(overlayToggle, "-=1s");
            new ScrollMagic.Scene({ offset: 0, duration: 100, triggerHook: 0 })
                .setTween(timeline)
                .addTo(__.controller);
        },

        // Function to call to setup functionality

        setup: function() {
            __.watchForClicks();
            __.watchForScroll();

            // __.checkScrollPosition();
        },
    };
    // Attach Toolbox to window //
    window._menu = __;
})(jQuery); // Fully reference jQuery after this point.288px 198px 100px